export default __webpack_public_path__ + "static/media/GRUPO_4_2026.ec4265ee.pdf";